<div class="">
  <div class="form-group">
    <label for="highestEducation">Highest Level of Education Completed<span class="requiredfield text-danger">*</span></label>
    
    <div class="dropdown-clear-wrapper mt-1">
      <select 
        id="highestEducation"
        class="form-control"
        [value]="selectedValue"
        [disabled]="disabled || readOnlyMode"
        (change)="onSelectionChange($event)"
        (blur)="onBlur()"
        (focus)="onFocus()"
        [attr.name]="name"
        [style.color]="selectedValue === '' ? '#757575' : '#010101'"
        [ngClass]="{'empty-select': selectedValue === '', 'is-invalid': (touched && !selectedValue) || showSpecificError}">
        
        <option disabled [selected]="!selectedValue">
          Select Highest Level
        </option>
        
        <option 
          *ngFor="let item of lookupData; trackBy: trackByFn" 
          [value]="item.key">
          {{ item.value }}
        </option>
      </select>

      <span class="select-dropdown-arrow material-symbols-outlined" aria-hidden="true">arrow_drop_down</span>
      
      <!-- <button
        *ngIf="selectedValue && !readOnlyMode && !disabled"
        type="button"
        class="clear-icon btn p-0 mt-1"
        (click)="clearSelection()"
        aria-label="Clear selection">
        <span class="material-symbols-outlined">close</span>
      </button> -->
    </div>
    
    <!-- Show specific error messages based on application type when modal is closed -->
    <div *ngIf="showSpecificError && specificErrorMessage">
      <div role="alert" class="text-danger mt-1 err-font">{{ specificErrorMessage }}</div>
    </div>
    
    <!-- Show required field error only when touched, empty, and no specific error is showing -->
    <div *ngIf="touched && !selectedValue && !showSpecificError">
      <div role="alert" class="text-danger mt-1 err-font">Please select your highest level of education completed.</div>
    </div>
  </div>
</div>

<ng-template #appTypeNoticeModal let-modal>
  <div class="modal-content">
    <div class="d-flex text-black modal-header pl-4 pr-4 mt-2">
      <h5 class="font-18 mt-1 font-weight-600">Application Type Notice</h5>
      <button type="button" class="btn p-0" aria-label="Close" (click)="closeModal()">
        <span class="material-symbols-outlined">
          close
        </span>
      </button>
    </div>
    
    <div class="modal-body">
      <div class="sub-heading">
        <p class="para-1 mb-2">{{ noticeHeading }}</p>
        <p class="para-1 mb-2">{{ noticeContent }}</p>
      </div>
    </div>
    
    <div class="btn-container">
        <button *ngIf="showProceedButton" 
              type="button" 
              class="btn btn-primary w-100 ml-0" 
              (click)="proceedWithApplication()">
        {{ buttonText }}
      </button>
      <button type="button" 
              class="btn btn-outline-secondary w-100 ml-0"  [ngClass]="showProceedButton?'mt-3':'mt-0'"
              (click)="closeModal()">
        Edit Education Selection
      </button>      
    </div>
  </div>
</ng-template>
